import client from "./client";

export type CityResponse = {
  city: string;
  id: number;
};

export const getCitiesByProvince = (province: string, country: string = ""): Promise<Array<CityResponse>> =>
  client
    .get(`/session/digitalJourney/accidentCities?province=${province}${country ? `&country=${country}` : ""}`)
    .then(({ data }) => data);
